export const ODDS_BOOST_URL = 'oddsboost';
export const SUPER_BOOST_URL = 'superbooster';
